module.exports = __webpack_public_path__ + "static/media/bullet-incheiat.dbd756b9.png";